import Layout from 'Components/Layout'
import { Button, Box, Center, Text, Flex, useDisclosure } from '@chakra-ui/react'
import ExaminationInstruction from 'Components/Headers/ExamInstruction'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDeviceType } from 'app/hooks'
import { useIdleTimer } from 'react-idle-timer'
import { useEffect, useState } from 'react'
import { userState } from 'Constants/userRegistrationStatus'
import { useLogoutUserMutation } from 'Services/API/posp.api'
import { ToastService } from 'Services/toast.service'
import { resetUser, updateUserState } from 'features/Authentication'
import { useSelector, useDispatch } from 'react-redux'
// import ExamFailModal from 'Components/ExamFailModal'
// import { USER_ID } from 'Constants';
const ExamInstruction = () => {
  const navigate = useNavigate()
  const { onClose } = useDisclosure()
  const { isMobile } = useDeviceType()
  const { isLoggedIn, authenticatedUser, journeyType } = useSelector((state: any) => state.user)
  const dispatch = useDispatch()
  const location = useLocation()
  // LOGOUT FUNCTIONALITIES

  // const [logoutUser] = useLogoutUserMutation({})

  // const handleLogout = async () => {
  //   try {
  //     const logoutUserResp = await logoutUser({
  //       idle: true,
  //     })
  //     // console.log(logoutUserResp)
  //     if (logoutUserResp?.data?.status && isLoggedIn) {
  //       ToastService.showInfoToast({
  //         title: 'Session Timeout',
  //         message: 'You have been auto logout due to inactivity',
  //       })
  //       navigate('/')
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       dispatch(resetUser())
  //       dispatch(updateUserState(userState))
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // // IDLE TIMER FOR AUTO LOGOUT
  // const [state, setState] = useState<string>('Active')
  // const [count, setCount] = useState<number>(0)
  // const [remaining, setRemaining] = useState<number>(0)

  // const onIdle = () => {
  //   // setState('Idle')
  //   handleLogout()
  // }

  // const onActive = () => {
  //   setState('Active')
  // }

  // const onAction = () => {
  //   setCount(count + 1)
  // }

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 10_000 * 6 * 5,
  //   throttle: 500,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })

  return (
    <>
      <Layout HeaderComponent={<ExaminationInstruction />}>
        <Box fontSize={isMobile ? 'xs' : 'md'} pt='1%' px={isMobile ? '6' : '10'}>
          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>
              1. The examination will consist of objective-type Multiple Choice Questions (MCQs).
              All questions are compulsory.
            </Text>
          </Box>
          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>
              2. The topics covered in the exam will be as per the training module.
            </Text>
          </Box>
          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>
              3. The candidates need to choose the right option from the multiple choices given with
              each question.
            </Text>
          </Box>
          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>
              4. Each question carries {journeyType === 'LIFE' ? 'one' : 'two'} mark.
            </Text>
          </Box>
          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>
              5. Total no. of questions will be {journeyType === 'LIFE' ? '100' : '25'} and the
              minimum marks required to pass the exam is 25.
            </Text>
          </Box>

          <Box pt={isMobile ? '3' : '4'}>
            <Text color='#828282'>6. There is no negative marking.</Text>
          </Box>
        </Box>
        <Center mt='8%' mb='8%'>
          <Flex justifyContent='space-between' gap='12'>
            <Box>
              <Button
                colorScheme='primary'
                variant='outline'
                onClick={() => {
                  navigate('/registration-status')
                }}
              >
                Back
              </Button>
            </Box>
            <Box>
              <Button
                colorScheme='primary'
                onClick={() => {
                  navigate(
                    journeyType === 'LIFE'
                      ? '/sp-registration/life-insurance-examination'
                      : '/sp-registration/general-insurance-examination',
                  )
                }}
              >
                <Text fontSize='sm'>Take The Exam</Text>
              </Button>
            </Box>
          </Flex>
        </Center>
      </Layout>
      {/* // {<ExamPassModal isOpen={true} onClose={onClose} />} */}
    </>
  )
}

export default ExamInstruction
